<template>
	<modal v-if="modalOpen">
		<div class="modal__inner modal__inner-narrow">
			<h2 class="modal__heading">Choose a topic</h2>

			<div class="selection-block-container">
				<selection-block
					v-for="(topic, index) in $store.state.topics"
					:key="index"
					:topic="topic"
				/>
			</div>
		</div>
	</modal>
</template>

<script>
// Components
import Modal from '@/components/global/Modal.vue';
import SelectionBlock from '@/components/blocks/SelectionBlock.vue';

export default {
	components: {
		Modal,
		SelectionBlock
	},
	computed: {
		modalOpen: {
			get() {
				return this.$store.state.modalsVisible.chooseTopic;
			},
			set(value) {
				this.$store.commit('modalVisible', {
					modal: 'chooseTopic',
					boolean: value
				});
			}
		}
	}
};
</script>
